export function parseDate(dateStr){
    let date;
    if(dateStr.match(/:/)) {
        let dateS = dateStr.split(' ')[0];
        let time = dateStr.split(' ')[1];
        date = new Date(dateS.split('-')[0],dateS.split('-')[1]-1,dateS.split('-')[2],time.split(':')[0],time.split(':')[1],time.split(':')[2]);
    } else {
        date = new Date(dateStr);
    }
    return{
        timestamp: date.getTime(),
        year: getTime(date.getFullYear(),4),
        month: getTime(date.getMonth()+1),
        day: getTime(date.getDate()),
        hour: getTime(dateStr?.length > 10 ? date.getHours() : 0),
        minutes: getTime(date.getMinutes()),
        seconds: getTime(date.getSeconds()),
        'm-d': `${getTime(date.getMonth()+1)}-${getTime(date.getDate())}`,
        'cn-m-d': `${getTime(date.getMonth()+1)}月${getTime(date.getDate())}日`,
        'hh:mm': `${getTime(dateStr?.length > 10 ? date.getHours() : '00')}:${getTime(date.getMinutes())}`
    }
}
function getTime(time, length=2){
    let ii = "0000000000" + time;
    return ii.substring(ii.length - length);
}
